// src/pages/EventoPage.js
import React, { useState, useEffect, useCallback } from 'react';
 
const bs  = { fontFamily: "'Montserrat', sans-serif" };
const ds  = { fontFamily: "'Cormorant Garamond', Georgia, serif" };
const API = '/api';
 
// ── Layout del Teatro 2 Centenario Coyoacán ───────────────────────────────
// Orden N→A (N arriba, A abajo cerca del escenario)
const LAYOUT_TEATRO = [
  { fila: 'N', bloques: [[1,2],     [],                                       []] },
  { fila: 'M', bloques: [[1,2],     [],                                       []] },
  { fila: 'L', bloques: [[1,2],     [null,null,3,4,5],                             [6,7,8,9,10,11]] },
  { fila: 'K', bloques: [[1,2,3],   [null,null,4,5,6,7],                           [8,9,10,11,12,13]] },
  { fila: 'J', bloques: [[1,2,3],   [4,5,6,7,8,9,10,11,12,13,14,15,16,17],   [18,19,20,21,22]] },
  { fila: 'I', bloques: [[1,2,3],   [4,5,6,7,8,9,10,11,12,13,14,15,16,17],   [18,19,20,21,22]] },
  { fila: 'H', bloques: [[1,2,3,4], [5,6,7,8,9,10,11,12,13,14,15,16,17,18],  [19,20,21,22]] },
  { fila: 'G', bloques: [[1,2,3,4], [5,6,7,8,9,10,11,12,13,14,15,16,17,18],  [19,20,21,22]] },
  { fila: 'F', bloques: [[1,2,3,4], [5,6,7,8,9,10,11,12,13,14,15,16,17,18],  [19,20,21,22]] },
  { fila: 'E', bloques: [[1,2,3,4], [5,6,7,8,9,10,11,12,13,14,15,16,17,18],  [19,20,21,22]] },
  { fila: 'D', bloques: [[1,2,3,4], [5,6,7,8,9,10,11,12,13,14,15,16,17,18],  [19,20,21,22]] },
  { fila: 'C', bloques: [[1,2,3,4], [5,6,7,8,9,10,11,12,13,14,15,16,17,18],  [19,20,21]] },
  { fila: 'B', bloques: [[1,2,3,4], [5,6,7,8,9,10,11,12,13,14,15,16,17,18],  [19,20,21]] },
  { fila: 'A', bloques: [[],        [5,6,7,8,9,10,11,12,13,14,15,16,17,18],  [19,20,21]] },
];

const CORTESIA_FILAS = ['D','E','F','G','H'];
const CORTESIA_NUMS  = [5,6,7,8,9,10,11,12,13,14,15,16,17,18];
 
// ── Colores de asientos ────────────────────────────────────────────────────
const colorAsiento = (estado, tipo, seleccionado) => {
  if (seleccionado)                   return { bg: '#961914', border: '#7a140f', text: 'white' };
  if (tipo === 'cortesia')            return { bg: '#6366f1', border: '#4f46e5', text: 'white' };
  if (estado === 'pagado')            return { bg: '#d1d5db', border: '#9ca3af', text: '#666' };
  if (estado === 'cortesia_asignado') return { bg: '#a5b4fc', border: '#818cf8', text: 'white' };
  if (estado === 'reservado')         return { bg: '#fbbf24', border: '#f59e0b', text: '#333' };
  return { bg: '#f0fdf4', border: '#86efac', text: '#16a34a' };
};
 
// ── Componente Asiento ─────────────────────────────────────────────────────
const Asiento = ({ asientoData, seleccionado, onClick }) => {
  if (!asientoData) return <div style={{ width: 22, height: 22, margin: '1px' }} />;
  const { estado, tipo } = asientoData;
  const libre  = estado === 'libre' && tipo !== 'cortesia';
  const c      = colorAsiento(estado, tipo, seleccionado);
  return (
    <div
      title={`Fila ${asientoData.fila} — Asiento ${asientoData.numero}${tipo === 'cortesia' ? ' (Cortesía)' : ''}`}
      onClick={() => libre && onClick(asientoData)}
      style={{
        width: 20, height: 20, margin: '1.5px',
        borderRadius: '3px 3px 5px 5px',
        background: c.bg, border: `1.5px solid ${c.border}`,
        cursor: libre ? 'pointer' : 'default',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '8px', fontWeight: 700, color: c.text,
        transition: 'transform 0.1s',
        transform: seleccionado ? 'scale(1.2)' : 'scale(1)',
        userSelect: 'none', flexShrink: 0,
      }}
    >
      {asientoData.numero}
    </div>
  );
};
 
// ── Formulario de compra ──────────────────────────────────────────────────
const FormularioCompra = ({ asiento, eventoId, onSuccess, onCancel }) => {
  const [nombre,   setNombre]   = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [email,    setEmail]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [paso,     setPaso]     = useState(1);
  const [boleto,   setBoleto]   = useState(null);
  const [archivo,  setArchivo]  = useState(null);
  const [subiendo, setSubiendo] = useState(false);
 
  const inp = {
    ...bs, width: '100%', padding: '10px 14px', border: '1px solid #e5e0e0',
    fontSize: '13px', color: '#060D14', outline: 'none', borderRadius: '2px',
    background: 'white', boxSizing: 'border-box', transition: 'border-color 0.2s',
  };
 
  const handleReservar = async () => {
    if (!nombre.trim() || !whatsapp.trim()) { alert('Completa tu nombre y WhatsApp'); return; }
    setLoading(true);
    try {
      const res  = await fetch(`${API}/reservar_boleto.php`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ asiento_id: asiento.id, evento_id: eventoId,
          nombre_comprador: nombre, whatsapp, email }),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.message);
      setBoleto(json.data); setPaso(2);
    } catch (e) { alert('Error: ' + e.message); }
    finally { setLoading(false); }
  };
 
  const handleSubirComprobante = async () => {
    if (!archivo) { alert('Selecciona tu comprobante de pago'); return; }
    setSubiendo(true);
    try {
      const form = new FormData();
      form.append('comprobante', archivo);
      form.append('boleto_id', boleto.boleto_id);
      form.append('qr_token',  boleto.qr_token);
      const res  = await fetch(`${API}/subir_comprobante.php`, { method: 'POST', body: form });
      const json = await res.json();
      if (!json.success) throw new Error(json.message);
      setPaso(3);
    } catch (e) { alert('Error al subir: ' + e.message); }
    finally { setSubiendo(false); }
  };
 
  return (
    <div style={{ background: 'white', borderRadius: '4px',
      boxShadow: '0 20px 60px rgba(0,0,0,0.15)', maxWidth: '440px',
      width: '100%', overflow: 'hidden' }}>
      <div style={{ background: '#961914', padding: '20px 24px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <p style={{ ...bs, color: 'rgba(255,255,255,0.7)', fontSize: '10px',
            letterSpacing: '0.2em', textTransform: 'uppercase', margin: '0 0 4px' }}>
            Asiento seleccionado
          </p>
          <p style={{ ...ds, color: 'white', fontSize: '1.4rem', margin: 0, fontWeight: 600 }}>
            Fila {asiento.fila} — Asiento {asiento.numero}
          </p>
        </div>
        <button onClick={onCancel} style={{ background: 'rgba(255,255,255,0.2)',
          border: 'none', color: 'white', width: '32px', height: '32px',
          borderRadius: '50%', cursor: 'pointer', fontSize: '16px' }}>×</button>
      </div>
      <div style={{ padding: '24px' }}>
        {paso === 1 && (
          <>
            <p style={{ ...bs, fontSize: '11px', color: '#bbb', letterSpacing: '0.15em',
              textTransform: 'uppercase', marginBottom: '16px' }}>Tus datos</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
              <div>
                <label style={{ ...bs, display: 'block', fontSize: '11px', color: '#999', marginBottom: '5px' }}>Nombre completo *</label>
                <input style={inp} value={nombre} onChange={e => setNombre(e.target.value)}
                  placeholder="Tu nombre completo"
                  onFocus={e => e.target.style.borderColor = '#961914'}
                  onBlur={e => e.target.style.borderColor = '#e5e0e0'} />
              </div>
              <div>
                <label style={{ ...bs, display: 'block', fontSize: '11px', color: '#999', marginBottom: '5px' }}>WhatsApp * (te enviaremos el QR aquí)</label>
                <input style={inp} value={whatsapp} onChange={e => setWhatsapp(e.target.value)}
                  placeholder="55 1234 5678"
                  onFocus={e => e.target.style.borderColor = '#961914'}
                  onBlur={e => e.target.style.borderColor = '#e5e0e0'} />
              </div>
              <div>
                <label style={{ ...bs, display: 'block', fontSize: '11px', color: '#999', marginBottom: '5px' }}>Email (opcional)</label>
                <input style={inp} value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  onFocus={e => e.target.style.borderColor = '#961914'}
                  onBlur={e => e.target.style.borderColor = '#e5e0e0'} />
              </div>
            </div>
            <div style={{ background: '#faf9f9', border: '1px solid #f0eaea',
              borderRadius: '2px', padding: '12px 16px', marginBottom: '20px',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ ...bs, fontSize: '13px', color: '#666' }}>Total a pagar</span>
              <span style={{ ...ds, fontSize: '1.6rem', color: '#961914', fontWeight: 600 }}>$100.00</span>
            </div>
            <button onClick={handleReservar} disabled={loading} style={{
              ...bs, width: '100%', background: '#961914', color: 'white', border: 'none',
              padding: '14px', cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '12px', fontWeight: 700, letterSpacing: '0.15em',
              textTransform: 'uppercase', borderRadius: '2px', opacity: loading ? 0.7 : 1,
            }}
            onMouseOver={e => { if (!loading) e.currentTarget.style.background = '#7a140f'; }}
            onMouseOut={e => e.currentTarget.style.background = '#961914'}>
              {loading ? 'Reservando…' : 'Continuar al Pago →'}
            </button>
            <p style={{ ...bs, fontSize: '10px', color: '#bbb', textAlign: 'center', marginTop: '10px' }}>
              Tu asiento se reserva por 30 minutos mientras realizas el pago
            </p>
          </>
        )}
        {paso === 2 && boleto && (
          <>
            <div style={{ background: '#f0fdf4', border: '1px solid #86efac',
              borderRadius: '2px', padding: '12px 16px', marginBottom: '20px' }}>
              <p style={{ ...bs, fontSize: '12px', color: '#16a34a', fontWeight: 600, margin: '0 0 4px' }}>
                ✓ Asiento reservado por 30 minutos
              </p>
              <p style={{ ...bs, fontSize: '11px', color: '#666', margin: 0 }}>
                Fila {asiento.fila} — Asiento {asiento.numero}
              </p>
            </div>
            <p style={{ ...bs, fontSize: '12px', color: '#666', marginBottom: '16px', lineHeight: 1.6 }}>
              <strong>Paso 1:</strong> Realiza tu pago de <strong>$100</strong> en MercadoPago:
            </p>
            <a href={boleto.mp_link} target="_blank" rel="noreferrer" style={{
              ...bs, display: 'block', background: '#009ee3', color: 'white',
              textDecoration: 'none', padding: '14px', textAlign: 'center',
              fontSize: '13px', fontWeight: 700, borderRadius: '4px',
              marginBottom: '20px', letterSpacing: '0.05em',
            }}>
              💳 Pagar $100 en MercadoPago
            </a>
            <p style={{ ...bs, fontSize: '12px', color: '#666', marginBottom: '12px', lineHeight: 1.6 }}>
              <strong>Paso 2:</strong> Sube tu comprobante de pago (captura de pantalla o recibo):
            </p>
            <input type="file" accept="image/*,.pdf"
              onChange={e => setArchivo(e.target.files[0])}
              style={{ ...bs, width: '100%', padding: '10px', border: '1px dashed #e5c9c9',
                borderRadius: '2px', fontSize: '12px', color: '#666',
                background: archivo ? '#f0fdf4' : 'white', marginBottom: '16px',
                boxSizing: 'border-box' }} />
            <button onClick={handleSubirComprobante} disabled={subiendo || !archivo} style={{
              ...bs, width: '100%', background: '#961914', color: 'white', border: 'none',
              padding: '14px', cursor: (subiendo || !archivo) ? 'not-allowed' : 'pointer',
              fontSize: '12px', fontWeight: 700, letterSpacing: '0.15em',
              textTransform: 'uppercase', borderRadius: '2px',
              opacity: (subiendo || !archivo) ? 0.5 : 1,
            }}>
              {subiendo ? 'Enviando…' : 'Enviar Comprobante'}
            </button>
          </>
        )}
        {paso === 3 && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎭</div>
            <h3 style={{ ...ds, fontSize: '1.6rem', color: '#060D14', margin: '0 0 12px' }}>
              ¡Listo! Comprobante recibido
            </h3>
            <p style={{ ...bs, fontSize: '13px', color: '#666', lineHeight: 1.7, marginBottom: '20px' }}>
              Revisaremos tu pago y te enviaremos tu boleto con código QR por WhatsApp a
              <strong> {whatsapp}</strong> en breve.
            </p>
            <div style={{ background: '#faf9f9', border: '1px solid #f0eaea',
              borderRadius: '2px', padding: '14px', marginBottom: '20px' }}>
              <p style={{ ...bs, fontSize: '11px', color: '#bbb', margin: '0 0 4px',
                letterSpacing: '0.12em', textTransform: 'uppercase' }}>Tu asiento</p>
              <p style={{ ...ds, fontSize: '1.3rem', color: '#961914', margin: 0 }}>
                Fila {asiento.fila} — Asiento {asiento.numero}
              </p>
            </div>
            <button onClick={onSuccess} style={{
              ...bs, background: '#961914', color: 'white', border: 'none',
              padding: '12px 28px', cursor: 'pointer', fontSize: '11px',
              fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase',
              borderRadius: '2px',
            }}>
              Cerrar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
 
// ── Página principal ───────────────────────────────────────────────────────
const EventoPage = () => {
  const [evento,       setEvento]       = useState(null);
  const [asientosMap,  setAsientosMap]  = useState({});
  const [loading,      setLoading]      = useState(true);
  const [seleccionado, setSeleccionado] = useState(null);
  const [showForm,     setShowForm]     = useState(false);
 
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API}/get_evento.php`);
      const json = await res.json();
      if (!json.success) return;
      setEvento(json.data.evento);
      const map = {};
      json.data.asientos.forEach(a => { map[`${a.fila}-${a.numero}`] = a; });
      setAsientosMap(map);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);
 
  useEffect(() => { load(); }, [load]);
 
  const handleSeleccionar = (asiento) => { setSeleccionado(asiento); setShowForm(true); };
  const handleSuccess = () => { setShowForm(false); setSeleccionado(null); load(); };
 
  if (loading) return (
    <div style={{ padding: '80px', textAlign: 'center' }}>
      <p style={{ ...bs, color: '#bbb', fontSize: '13px' }}>Cargando evento…</p>
    </div>
  );
  if (!evento) return (
    <div style={{ padding: '80px', textAlign: 'center' }}>
      <p style={{ ...ds, fontSize: '1.4rem', color: '#bbb' }}>No hay eventos disponibles próximamente.</p>
    </div>
  );

  // FIX: parseo seguro de fecha MySQL ("2025-07-25 19:00:00" → reemplazar espacio por T)
  const parseFecha = (str) => {
    if (!str) return null;
    const d = new Date(str.replace(' ', 'T'));
    return isNaN(d.getTime()) ? null : d;
  };
  const fecha    = parseFecha(evento.fecha);
  const fechaFmt = fecha
    ? fecha.toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
    : 'Por confirmar';
  const horaFmt  = fecha
    ? fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })
    : '';
 
  return (
    <div style={{ background: '#faf9f9', minHeight: '100vh' }}>

      {/* Hero */}
      <section style={{ background: '#060D14', padding: 'clamp(48px,6vw,72px) 24px', textAlign: 'center' }}>
        <p style={{ ...bs, color: 'rgba(255,255,255,0.4)', fontSize: '10px',
          letterSpacing: '0.38em', textTransform: 'uppercase', marginBottom: '12px' }}>
          Eledé Estudio de Danza — Evento Especial
        </p>
        <h1 style={{ ...ds, fontSize: 'clamp(1.8rem,4vw,3rem)', fontWeight: 300,
          color: 'white', lineHeight: 1.2, margin: '0 0 20px' }}>
          {evento.nombre}
        </h1>
        {evento.descripcion && (
          <p style={{ ...bs, color: 'rgba(255,255,255,0.6)', fontSize: '13px',
            maxWidth: '560px', margin: '0 auto 24px', lineHeight: 1.8 }}>
            {evento.descripcion}
          </p>
        )}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '32px', flexWrap: 'wrap', marginBottom: '24px' }}>
          {[
            { icon: '📅', label: 'Fecha',  val: fechaFmt },
            { icon: '🕖', label: 'Hora',   val: horaFmt ? horaFmt + ' hrs' : 'Por confirmar' },
            { icon: '📍', label: 'Lugar',  val: evento.lugar },
            { icon: '🎟', label: 'Boleto', val: `$${Number(evento.precio_base).toFixed(0)} MXN` },
          ].map(({ icon, label, val }) => (
            <div key={label} style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '20px', margin: '0 0 4px' }}>{icon}</p>
              <p style={{ ...bs, fontSize: '9px', color: 'rgba(255,255,255,0.4)',
                letterSpacing: '0.2em', textTransform: 'uppercase', margin: '0 0 2px' }}>{label}</p>
              <p style={{ ...bs, fontSize: '12px', color: 'white', margin: 0, maxWidth: '200px' }}>{val}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Leyenda */}
      <section style={{ background: 'white', padding: '16px 24px', borderBottom: '1px solid #f0eaea' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto',
          display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
          <p style={{ ...bs, fontSize: '11px', color: '#999', margin: 0 }}>Leyenda:</p>
          {[
            { color: '#f0fdf4', border: '#86efac', label: 'Disponible' },
            { color: '#961914', border: '#7a140f', label: 'Seleccionado' },
            { color: '#6366f1', border: '#4f46e5', label: 'Cortesía' },
            { color: '#fbbf24', border: '#f59e0b', label: 'Reservado' },
            { color: '#d1d5db', border: '#9ca3af', label: 'Ocupado' },
          ].map(({ color, border, label }) => (
            <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: 16, height: 16, borderRadius: '3px',
                background: color, border: `1.5px solid ${border}` }} />
              <span style={{ ...bs, fontSize: '11px', color: '#666' }}>{label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── Mapa del teatro ── */}
      <section style={{ padding: 'clamp(24px,4vw,48px) 16px', background: '#faf9f9' }}>
        <div style={{ maxWidth: '960px', margin: '0 auto' }}>

          {/* Filas de asientos — bloques con ancho fijo para columnas alineadas */}
          <div style={{
            background: 'white', border: '1px solid #f0eaea',
            borderRadius: '2px 2px 0 0', padding: '20px 16px 12px',
            overflowX: 'auto',
          }}>
            {LAYOUT_TEATRO.map(({ fila, bloques }) => (
              <div key={fila} style={{
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', marginBottom: '4px',
              }}>
                {/* Etiqueta izquierda */}
                <span style={{ ...bs, fontSize: '11px', fontWeight: 700, color: '#999',
                  width: '18px', textAlign: 'center', flexShrink: 0, marginRight: '6px' }}>
                  {fila}
                </span>

                {/* Bloque izquierdo — ancho fijo, asientos pegados al borde EXTERIOR (flex-start) */}
                <div style={{ display: 'flex', width: '92px', justifyContent: 'flex-start', flexShrink: 0 }}>
                  {bloques[0].map(num => {
                    const a = asientosMap[`${fila}-${num}`];
                    return <Asiento key={num} asientoData={a}
                      seleccionado={seleccionado?.id === a?.id} onClick={handleSeleccionar} />;
                  })}
                </div>

                {/* Pasillo izquierdo */}
                <div style={{ width: '18px', flexShrink: 0 }} />

                {/* Bloque central — L y K flex-start para alinear col4 con J; resto centrado */}
                <div style={{ display: 'flex', width: '396px', flexShrink: 0,
                  justifyContent: ['L','K'].includes(fila) ? 'flex-start' : 'center' }}>
                  {bloques[1].map((num, idx) => {
                    if (num === null) return <div key={`gap-${idx}`} style={{ width: 23, flexShrink: 0 }} />;
                    const a = asientosMap[`${fila}-${num}`];
                    return <Asiento key={num} asientoData={a}
                      seleccionado={seleccionado?.id === a?.id} onClick={handleSeleccionar} />;
                  })}
                </div>

                {/* Pasillo derecho */}
                <div style={{ width: '18px', flexShrink: 0 }} />

                {/* Bloque derecho — ancho fijo, asientos pegados al borde EXTERIOR (flex-end) */}
                <div style={{ display: 'flex', width: '115px', justifyContent: 'flex-end', flexShrink: 0 }}>
                  {bloques[2].map(num => {
                    const a = asientosMap[`${fila}-${num}`];
                    return <Asiento key={num} asientoData={a}
                      seleccionado={seleccionado?.id === a?.id} onClick={handleSeleccionar} />;
                  })}
                </div>

                {/* Etiqueta derecha */}
                <span style={{ ...bs, fontSize: '11px', fontWeight: 700, color: '#999',
                  width: '18px', textAlign: 'center', flexShrink: 0, marginLeft: '6px' }}>
                  {fila}
                </span>
              </div>
            ))}
          </div>

          {/* Escenario pegado debajo */}
          <div style={{
            background: 'linear-gradient(135deg, #060D14, #1a2a3a)',
            color: 'white', textAlign: 'center', padding: '18px',
            borderRadius: '0 0 60px 60px',
            ...bs, fontSize: '13px', fontWeight: 700,
            letterSpacing: '0.35em', textTransform: 'uppercase',
          }}>
            ✦ ESCENARIO ✦
          </div>

          <p style={{ ...bs, fontSize: '11px', color: '#bbb', textAlign: 'center', marginTop: '12px' }}>
            Toca un asiento verde para seleccionarlo · Los asientos morados son de cortesía reservada
          </p>
        </div>
      </section>

      {/* Modal de compra */}
      {showForm && seleccionado && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 200,
          background: 'rgba(6,13,20,0.8)', backdropFilter: 'blur(6px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '16px', overflowY: 'auto' }}>
          <FormularioCompra
            asiento={seleccionado}
            eventoId={parseInt(evento.id)}
            onSuccess={handleSuccess}
            onCancel={() => { setShowForm(false); setSeleccionado(null); }}
          />
        </div>
      )}
    </div>
  );
};
 
export default EventoPage;
